const modal = document.getElementById("sizeChartModal");
  const btn = document.getElementById("openSizeChart");
  const span = document.querySelector(".close");

  btn.onclick = function() {
    modal.style.display = "block";
  }

  span.onclick = function() {
    modal.style.display = "none";
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }